// Libraries
import styled from "styled-components"


export const VentureFacilitiesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
`

